/* Бесшовная лента статей LISHÉ. Версия 19.10.2026: без кнопки, без остановки и потолка.
   Спека: SCROLL_spec.md. Решение Светы 19.10: «подгружалось без кнопок непрерывно». */
(function () {
  "use strict";
  var root = document.querySelector("article.lishe-article[data-read-next]");
  if (!root) return;
  var qs = new URLSearchParams(location.search);
  // (г) отладка: noscroll=1 отключает ленту
  if (qs.get("noscroll") === "1") return;
  // (д) экономия трафика и медленная сеть: ленты нет
  var conn = navigator.connection;
  if ((conn && (conn.saveData || /2g$/.test(conn.effectiveType || ""))) ||
      !("IntersectionObserver" in window) || !window.fetch || !window.DOMParser) return;

  var KEEP = 3; // сколько статей назад держим с картинками
  var queue = [], seen = {}, loaded = 0, busy = false, armed = false;
  var preview = qs.get("preview_theme_id");
  var arts = [root]; // все статьи ленты по порядку, для выгрузки картинок

  function norm(u) { return new URL(u, location.origin).pathname.replace(/\/$/, ""); }
  // очередь: уже показанные пропускаем, дублей нет
  function enqueue(list) {
    (list || "").split("|").forEach(function (u) {
      u = u.trim();
      if (!u) return;
      var p = norm(u);
      if (!seen[p]) { seen[p] = true; queue.push(p); }
    });
  }
  seen[norm(location.pathname)] = true;
  enqueue(root.getAttribute("data-read-next"));
  if (!queue.length) return;

  root.setAttribute("data-url", location.pathname + location.search);
  root.setAttribute("data-title", document.title);
  var canon = document.querySelector('link[rel="canonical"]');
  if (canon) root.setAttribute("data-canonical", canon.href);

  var feed = document.createElement("div");
  feed.className = "lishe-feed";
  root.parentNode.insertBefore(feed, root.nextSibling);
  var sentinel = document.createElement("div");
  sentinel.className = "lishe-feed__sentinel";
  sentinel.setAttribute("aria-hidden", "true");
  sentinel.textContent = "​";
  feed.parentNode.insertBefore(sentinel, feed.nextSibling);
  var style = document.createElement("style");
  style.textContent = ".lishe-feed>article{margin-top:72px}.lishe-feed__sentinel{height:1px;overflow:hidden}";
  document.head.appendChild(style);

  var current = root, pushed = {}, jumping = false;
  pushed[root.getAttribute("data-url")] = true;

  // (з) защита телефона: картинки статей, ушедших выше чем на KEEP статей, выгружаем.
  // Высоту статьи фиксируем min-height, чтобы страница не прыгала.
  function setImages(art, off) {
    if (off === !!art._lfOff) return;
    art._lfOff = off;
    if (off) art.style.minHeight = art.offsetHeight + "px";
    art.querySelectorAll("img").forEach(function (img) {
      if (off) {
        if (img.getAttribute("src")) { img.setAttribute("data-src", img.getAttribute("src")); img.removeAttribute("src"); }
        if (img.getAttribute("srcset")) { img.setAttribute("data-srcset", img.getAttribute("srcset")); img.removeAttribute("srcset"); }
      } else {
        if (img.getAttribute("data-src")) { img.setAttribute("src", img.getAttribute("data-src")); img.removeAttribute("data-src"); }
        if (img.getAttribute("data-srcset")) { img.setAttribute("srcset", img.getAttribute("data-srcset")); img.removeAttribute("data-srcset"); }
      }
    });
  }
  function trim() {
    var i = arts.indexOf(current);
    arts.forEach(function (a, k) { setImages(a, k < i - KEEP); });
  }

  function show(art) {
    current = art;
    document.title = art.getAttribute("data-title") || document.title;
    if (canon && art.getAttribute("data-canonical")) canon.href = art.getAttribute("data-canonical");
    trim();
  }

  // (в) pushState на видимую статью
  var spy = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (jumping || !e.isIntersecting || e.target === current) return;
      var url = e.target.getAttribute("data-url");
      if (pushed[url]) history.replaceState({ lisheFeed: url }, "", url);
      else { pushed[url] = true; history.pushState({ lisheFeed: url }, "", url); }
      show(e.target);
    });
  }, { rootMargin: "-45% 0px -54% 0px" });
  history.replaceState({ lisheFeed: root.getAttribute("data-url") }, "");

  window.addEventListener("popstate", function () {
    var here = norm(location.pathname), list = document.querySelectorAll("article.lishe-article[data-url]");
    for (var k = 0; k < list.length; k++) {
      if (norm(list[k].getAttribute("data-url")) === here) {
        jumping = true;
        setImages(list[k], false);
        list[k].scrollIntoView({ block: "start" });
        show(list[k]);
        setTimeout(function () { jumping = false; }, 600);
        return;
      }
    }
  });

  // (е) чистка фрагмента + (б) H1 -> H2
  function clean(art, doc, n) {
    art.querySelectorAll("script, noscript, style").forEach(function (x) { x.remove(); });
    art.querySelectorAll("h2").forEach(function (h) {
      if (h.textContent.trim().toLowerCase() === "read next") {
        for (var x = h.nextElementSibling; x && !/^H[12]$/.test(x.tagName);) {
          var next = x.nextElementSibling; x.remove(); x = next;
        }
        h.remove();
      }
    });
    art.querySelectorAll("h1").forEach(function (h) {
      var h2 = doc.createElement("h2");
      h2.className = ((h.className || "") + " lishe-feed__title").trim();
      h2.innerHTML = h.innerHTML;
      h.parentNode.replaceChild(h2, h);
    });
    var pre = "f" + n + "-";
    art.querySelectorAll("[id]").forEach(function (x) { x.id = pre + x.id; });
    art.querySelectorAll('a[href^="#"]').forEach(function (a) {
      if (a.getAttribute("href").length > 1) a.setAttribute("href", "#" + pre + a.getAttribute("href").slice(1));
    });
  }

  function load() {
    if (busy || !queue.length) return;
    busy = true;
    var p = queue.shift();
    fetch(p + (preview ? "?preview_theme_id=" + encodeURIComponent(preview) : ""), { credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var art = doc.querySelector("article.lishe-article");
        if (!art) throw new Error("no article");
        enqueue(art.getAttribute("data-read-next"));
        loaded += 1;
        clean(art, doc, loaded);
        var c = doc.querySelector('link[rel="canonical"]');
        art.setAttribute("data-url", p + (preview ? "?preview_theme_id=" + encodeURIComponent(preview) : ""));
        art.setAttribute("data-title", doc.title);
        art.setAttribute("data-canonical", c ? c.href : location.origin + p);
        art.removeAttribute("data-read-next");
        var node = document.importNode(art, true);
        feed.appendChild(node);
        arts.push(node);
        spy.observe(node);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        // sentinel мог остаться в зоне подгрузки: пере-наблюдение даёт новый вызов
        if (queue.length) { near.unobserve(sentinel); near.observe(sentinel); }
      });
  }

  // следующая статья грузится, когда читатель близко к концу текущей ленты
  var near = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) load();
  }, { rootMargin: "0px 0px 1200px 0px" });

  // (а) старт только после первого жеста человека (так Google ленту не запускает)
  var GESTURES = ["wheel", "touchmove", "keydown", "pointerdown"];
  function arm() {
    if (armed) return;
    armed = true;
    GESTURES.forEach(function (g) { window.removeEventListener(g, arm, true); });
    spy.observe(root);
    near.observe(sentinel);
  }
  GESTURES.forEach(function (g) { window.addEventListener(g, arm, { capture: true, passive: true }); });
})();
